<div class="modal" #imageModal>
  <span class="close" (click)="close($event)">&times;</span>
  <img class="modal-content" #imageModalImg [src]="images[currentImage]">
  <div id="caption"></div>
</div>
